const storageKey = 'LoginReturnUrl'

export function rememberLoginReturnUrl(path: string) {
    if(isInternalPath(path)) {
        window.sessionStorage.setItem(storageKey, path)
    }
}

export function consumeLoginReturnUrl(): string|null {
    const path = window.sessionStorage.getItem(storageKey)
    window.sessionStorage.removeItem(storageKey)
    return path && isInternalPath(path) ? path : null
}

export function internalLoginReturnUrl(path?: string|null): string|null {
    return path && isInternalPath(path) ? path : null
}

function isInternalPath(path: string): boolean {
    return path.startsWith('/') && !path.startsWith('//')
}
